import store from '@/store';
import {$http} from '@/utils/https'
import {
    SET_LOADING_SLIDER_PRODUCTS,
    SET_SLIDER_PRODUCTS,
} from '../mutation-types';

import {
    GET_SLIDER_PRODUCTS,
} from '../action-types';


const state = {
    sliderProductsList: null,
    sliderProductsListLoading: false
};

const getters = {
    sliderProductsList: state => state.sliderProductsList,
    sliderProductsListLoading: state => state.sliderProductsListLoading,
};

const actions = {
    [GET_SLIDER_PRODUCTS]: async ({commit}) => {
        commit(SET_LOADING_SLIDER_PRODUCTS, true);
        try {
            const response = await $http.get('v1/products/popular');
            commit(SET_SLIDER_PRODUCTS, response.data.data);
        } catch (e) {
            throw e;
        } finally {
            commit(SET_LOADING_SLIDER_PRODUCTS, false);
        }
    },
};

const mutations = {
    [SET_SLIDER_PRODUCTS](state, list) {
        const transformProducts = list.map(e => {
            e.isBasket = false;
            return e;
        });


        let basketList = store.state.basket.basket;
        transformProducts.map(e => {
            return basketList.map(t => {
                if (e.id === t.id) {
                    e.isBasket = true;
                }
                return e;
            })
        });

        state.sliderProductsList = transformProducts;
    },
    [SET_LOADING_SLIDER_PRODUCTS](state, status) {
        state.sliderProductsListLoading = status;
    },
};
export default {
    state,
    getters,
    actions,
    mutations,
};
